module.exports = __webpack_public_path__ + "img/icon-event-expenses.1c03a855.svg";